import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, of, Subscription } from "rxjs";
import { delay, finalize, map, tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ApplicationUser } from "../models/application-user";
import { LoginResult } from "../models/login-result";
import jwt_decode from "jwt-decode";
import { Contact } from "../argic/models/contact";

@Injectable({
    providedIn: "root",
})
export class LoginService implements OnDestroy {
    private readonly apiUrl = `${environment.apiUrl}api`;
    private timer: Subscription;
    private sub: Subscription;
    public freqs: any[] = [];
    public userprofile: any = {};
    private user = new BehaviorSubject<ApplicationUser>(null);
    user$: Observable<ApplicationUser> = this.user.asObservable();

    private contact = new BehaviorSubject<Contact>(null);
    contact$: Observable<Contact> = this.contact.asObservable();

    constructor(private router: Router, private http: HttpClient) {
        window.addEventListener(
            "storage",
            this.storageEventListener.bind(this)
        );
        if (localStorage.getItem("access_token") != null) {
            const token: string = localStorage.getItem("access_token") || "";
            const username: string = localStorage.getItem("username") || "";
            let decoded: any = jwt_decode(token);
            this.user = new BehaviorSubject<ApplicationUser>({
                username: username,
                languageId: 1, //decoded.argic.contact.LanguageId,
                argicModel: decoded.argic,
            });
            this.user$ = this.user.asObservable();
        }

        this.timer = new Subscription();

        this.sub = this.user.subscribe((x) => {
            this.userprofile = x;
            console.log(this.userprofile);
            this.freqs = [];

            if (x != null && x.argicModel != null) {
                this.freqs.push(
                    x.argicModel.membergroup.DownLoad.trim().toLowerCase()
                );
            }
        });
        this.http
            .get<any>(`${environment.apiWizardUrl}Account/UserInfo`, {
                withCredentials: true,
            })
            .subscribe((x) => {
                this.user.next({
                    username: x.login,
                    userid: x.userid,
                    role: "1",
                    login:x.login,
                    languageId: parseInt(x.languageid), //decoded.argic.contact.LanguageId,
                    argicModel: null,
                });
            });

        this.http
            .get<any>(`${environment.apiWizardUrl}Account/Contact`, {
                withCredentials: true,
            })
            .subscribe((x) => {
                this.contact.next({
                    contactModel: x,
                });
            });
    }

    private storageEventListener(event: StorageEvent): void {
        if (event.storageArea === localStorage) {
            if (event.key === "logout-event") {
                this.user.next({});
            }
            if (event.key === "login-event") {
                location.reload();
            }
        }
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
        window.removeEventListener(
            "storage",
            this.storageEventListener.bind(this)
        );
    }

    login(username: string, password: string): Observable<LoginResult> {
        return this.http
            .post<LoginResult>(`${this.apiUrl}/Authenticate/login`, {
                username,
                password,
            })
            .pipe(
                map((x) => {
                    let decoded: any = jwt_decode(x.token);
                    var decodedHeader = jwt_decode(x.token, { header: true });

                    this.user.next({
                        username: username,
                        role: x.role,
                        languageId: 1, //decoded.argic.contact.LanguageId,
                        argicModel: decoded.argic,
                    });
                    this.setLocalStorage(x, username);
                    localStorage.setItem(
                        "login-event",
                        "login" + Math.random()
                    );
                    this.startTokenTimer();
                    this.router.navigateByUrl("/myargic");
                    return x;
                })
            );
    }

    logout(): void {
        this.http
            .post<unknown>(`${this.apiUrl}/logout`, {})
            .pipe(
                finalize(() => {
                    this.clearLocalStorage();
                    this.user.next({});
                    this.stopTokenTimer();
                    this.router.navigate(["login"]);
                })
            )
            .subscribe();
    }

    refreshToken(): Observable<any> {
        const refreshToken = localStorage.getItem("refresh_token");
        const username = localStorage.getItem("username");
        if (!refreshToken) {
            this.clearLocalStorage();
            return of(null);
        }

        return this.http
            .post<LoginResult>(`${this.apiUrl}/refresh-token`, { refreshToken })
            .pipe(
                map((x) => {
                    let decoded: any = jwt_decode(x.token);
                    this.user.next({
                        username: username,
                        role: x.role,
                        originalUserName: username,
                        languageId: decoded.argic.contact.LanguageId,
                        argicModel: decoded.argic,
                    });
                    this.setLocalStorage(x, username);
                    this.startTokenTimer();
                    return x;
                })
            );
    }

    setLocalStorage(x: LoginResult, username): void {
        localStorage.setItem("access_token", x.token);
        localStorage.setItem("refresh_token", x.refreshToken);
        localStorage.setItem("login-event", "login" + Math.random());
        localStorage.setItem("username", username);
    }

    clearLocalStorage(): void {
        localStorage.removeItem("username");
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.setItem("logout-event", "logout" + Math.random());
    }

    private getTokenRemainingTime(): number {
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            return 0;
        }
        const jwtToken = JSON.parse(atob(accessToken.split(".")[1]));
        const expires = new Date(jwtToken.exp * 1000);
        return expires.getTime() - Date.now();
    }

    private startTokenTimer(): void {
        const timeout = this.getTokenRemainingTime();
        this.timer = of(true)
            .pipe(
                delay(timeout),
                tap(() => this.refreshToken().subscribe())
            )
            .subscribe();
    }

    private stopTokenTimer(): void {
        this.timer?.unsubscribe();
    }

    public changepass(password: string, password2: string): Observable<LoginResult> {
        return this.http.post<LoginResult>(
            `${environment.apiWizardUrl}/Account/ChangePassword`,
            {
                username: "changepass",
                password: password,
                passwordConfirm: password2
            }
            ,
            {
                withCredentials: true,
            }
        );
    }

    public changelang(lang: string): Observable<LoginResult> {
        return this.http.post<LoginResult>(
            `${environment.apiWizardUrl}/Account/ChangeLanguage`,
            {
                lang: lang,
            },
            {
                withCredentials: true,
            }
        );
    }




}
